import { useCallback } from 'react'
import { InternalPayItemConnectionClassType, Permission } from 'shared'
import { useCheckPermission } from 'hooks/useCheckPermission'

/**
 * returns a callback and permissions to help check to see if various internal
 * connections can be viewed by the current user
 */
export function useCanView() {
  const canViewCAS = useCheckPermission(
    Permission.ViewConstructionAdminSubmittal
  )
  const canViewDS = useCheckPermission(Permission.ViewDesignSubmittal)
  const canViewConcrete = useCheckPermission(Permission.ViewConcreteTestSet)
  const canViewFDC = useCheckPermission(Permission.ViewFieldDesignChange)
  const canViewIssue = useCheckPermission(Permission.ViewIssue)
  const canViewEJ = useCheckPermission(Permission.ViewEngineeringJudgement)
  return useCallback(
    (internalId: string) => {
      const { classType } =
        InternalPayItemConnectionClassType.fromIdOrFail(internalId)
      if (classType === 'ConcreteTestSet') return canViewConcrete
      else if (classType === 'ConstructionAdminSubmittal') return canViewCAS
      else if (classType === 'DesignSubmittal') return canViewDS
      else if (classType === 'FieldDesignChange') return canViewFDC
      else if (classType === 'Issue') return canViewIssue
      else if (classType === 'EngineeringJudgement') return canViewEJ
      else return true
    },
    [
      canViewCAS,
      canViewConcrete,
      canViewDS,
      canViewFDC,
      canViewIssue,
      canViewEJ,
    ]
  )
}
